
import { Options, Vue } from "vue-property-decorator";

@Options({
  props: {
    formName: {},
    formDesc: {},
  },
  components: {}
})
export default class FormHeader extends Vue {
  private formName!: any;
  private formDesc!: any;
}

